import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["alt", "src"]
const _hoisted_4 = ["innerHTML"]

import { castingServicesCollection }from '@/data/castingServices';


export default /*@__PURE__*/_defineComponent({
  __name: 'castingServices',
  props: {
    imageTitletextCollection: {},
    pAHref: {},
    center: { type: Boolean, default: false },
    span: { default: 6 },
    strong: { type: Boolean, default: false },
    h2Title: {},
    pTitle: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.h2Title)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString(_ctx.h2Title), 1))
      : _createCommentVNode("", true),
    (_ctx.pTitle && _ctx.pTitle.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pTitle, (item, index) => {
            return (_openBlock(), _createElementBlock("p", {
              style: {"text-align":"center"},
              key: index
            }, _toDisplayString(item), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_row, {
      class: "content3",
      gutter: 30
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(castingServicesCollection), (item, index) => {
          return (_openBlock(), _createBlock(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 12,
            lg: 12,
            key: index
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, {
                class: "content3",
                gutter: 30
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, {
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 12
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        alt: item.alt,
                        src: item.imgUrl
                      }, null, 8, _hoisted_3)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_col, {
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 12
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", null, _toDisplayString(item.title), 1),
                      _createElementVNode("span", {
                        innerHTML: item.text
                      }, null, 8, _hoisted_4)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}
}

})